import React, {useMemo} from 'react'
import styled from 'styled-components'

import {getPerson} from '@api/requests'

import useIsPremium from '@app/hooks/useIsPremium'

import {useSubTreeModalStore} from '@components/molecules/SubTreeModal/SubTreeModal'
import {useSubscriptionModalStore} from '@components/molecules/SubscriptionModal/SubscriptionModal'
import {usePersonsStore} from '@store/persons'

import {KTIcon} from '@_metronic/helpers'
import {NODE_HEIGHT} from '@components/organisms/Tree/constants'
import {PersonModel, TreeModel} from '@api/models'

type SubTreeButtonProps = {
  personId: PersonModel['id'] | null
  treeId?: TreeModel['id']
  hover: boolean
  nodeSize: number
  avatarBorderWidthParsed: number
  editMode: boolean
}
const SubTreeButton = ({
  personId,
  treeId,
  nodeSize = NODE_HEIGHT,
  hover,
  avatarBorderWidthParsed,
  editMode,
}: SubTreeButtonProps) => {
  const is_premium = useIsPremium()

  const {show: showSubTreeOfPerson} = useSubTreeModalStore()
  const {show: showSubscriptionModal} = useSubscriptionModalStore()

  const {persons, updatePersons} = usePersonsStore()
  const personIndex = useMemo(
    () => persons.findIndex(({id}) => id === personId),
    [personId, persons]
  )
  const person = personIndex !== -1 ? persons[personIndex] : null
  // console.log('#### SubTreeButton', personId, person, persons)

  const koef = nodeSize / NODE_HEIGHT
  // console.log('### koef', koef, nodeSize, NODE_HEIGHT)

  const handleOpenSubTreeClick = (event) => {
    event.preventDefault()
    event.stopPropagation()

    // console.log('### person?.id && treeId', person?.id, treeId)
    if (person?.id && treeId) {
      getPerson(person.id).then((response) => {
        // console.log('### getPerson!', response)
        const personsClone = [...persons]

        const receivedPerson = response.data
        console.log('### personsClone', personsClone)
        const indexOfPerson = personsClone.findIndex(({id}) => receivedPerson.id === id)
        if (indexOfPerson !== -1) {
          // @ts-ignore
          personsClone[indexOfPerson] = receivedPerson
          updatePersons(personsClone, true, () => {
            if (!receivedPerson.subtree && !is_premium) {
              showSubscriptionModal()
              event.preventDefault()
              event.stopPropagation()

              return
            }

            // console.log('### SHOW')
            showSubTreeOfPerson({personId: person.id, treeId})
          })
        }
      })
    }
  }

  if (!person) return null

  if (person?.is_subtree) {
    return (
      <OpenSubTreeButton
        $koef={koef}
        $avatarBorderWidth={avatarBorderWidthParsed * 2}
        onClick={handleOpenSubTreeClick}
      >
        <i className='ki-duotone ki-data'>
          <span className='path1' />
          <span className='path2' />
          <span className='path3' />
          <span className='path4' />
          <span className='path5' />
        </i>
      </OpenSubTreeButton>
    )
  }

  if (hover && editMode && !person.is_subtree) {
    return (
      <OpenSubTreeButton
        $plus
        $koef={koef}
        $avatarBorderWidth={avatarBorderWidthParsed}
        onClick={handleOpenSubTreeClick}
      >
        <PlusIconWrapper>
          <KTIcon iconName='plus' className='fs-7' />
        </PlusIconWrapper>
        <i className='ki-duotone ki-data'>
          <span className='path1' />
          <span className='path2' />
          <span className='path3' />
          <span className='path4' />
          <span className='path5' />
        </i>
      </OpenSubTreeButton>
    )
  }

  return null
}

export default React.memo(SubTreeButton)

const BUTTON_SIZE = 24
const OpenSubTreeButton = styled.div<{$koef: number; $avatarBorderWidth: number; $plus?: boolean}>`
  background-color: white;
  width: ${BUTTON_SIZE}px;
  height: ${BUTTON_SIZE}px;
  border-radius: ${BUTTON_SIZE / 2}px;

  position: absolute;

  top: -${({$koef}) => BUTTON_SIZE / 2 - 8 + 7 * (1 - $koef)}px;
  right: -${({$koef}) => BUTTON_SIZE / 2 - 7 + 10 * (1 - $koef)}px;

  z-index: ${({$plus}) => ($plus ? 22 : 1)};

  &:hover {
    opacity: 0.8;
  }

  display: flex;
  justify-content: center;
  align-items: center;
`

const PlusIconWrapper = styled.div`
  position: absolute;
  left: -6px;
  top: 8px;
  height: 15px;
  width: 15px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: white;

  i {
    font-size: 12px !important;
  }
`
